import { axiosHelper, POST_METHOD, GET_METHOD } from './helper'
import { RegisterPayload, SocialRegisterPayload, EmailProviderBindingPayload } from './type'

export function register(payload: RegisterPayload) {
  return axiosHelper(POST_METHOD, '/web/register', payload)
}

export function socialRegister(payload: SocialRegisterPayload) {
  return axiosHelper(POST_METHOD, '/web/email-binding', payload)
}

export function emailProviderBinding(payload: EmailProviderBindingPayload) {
  return axiosHelper(POST_METHOD, '/web/email-provider-binding', payload)
}

export function getProviderInfo(challenge: string) {
  return axiosHelper(GET_METHOD, `/email-binding/register-data?challenge=${challenge}`, null)
}

export function getUserProviderList(challenge: string) {
  return axiosHelper(GET_METHOD, `/user/provider-list/provider-binding?challenge=${challenge}`, null)
}
